document.addEventListener('DOMContentLoaded', function() {
  // --- Existing Modal Logic (Copied from previous working code) ---
  const customFormModal = document.getElementById('CustomProductFormModal');
  const customFormModalCloseButton = document.getElementById('CustomProductFormModalClose');
  const customProductAddForm = document.getElementById('CustomProductAddForm');
  const modalProductTitleSpan = customFormModal ? customFormModal.querySelector('.quick-add-modal__product-title') : null;
  const modalProductVariantIdInput = customFormModal ? customFormModal.querySelector('.modal-product-variant-id') : null;
  const modalProductTagsInput = customFormModal ? customFormModal.querySelector('.modal-product-tags') : null;
  const modalProductHandleInput = customFormModal ? customFormModal.querySelector('.modal-product-handle') : null;
  const modalAddToCartButton = customFormModal ? customFormModal.querySelector('.add-to-cart-modal-button') : null;

  const modalPurposeField = document.getElementById('modal-sf-purpose');
  const modalPurposeOtherInput = document.getElementById('modal-sf-purpose-other');
  const modalPurposeOtherDiv = document.getElementById('modal-sf-purpose-other-field');
  const modalRoleField = document.getElementById('modal-sf-role');
  const modalRoleOtherInput = document.getElementById('modal-sf-role-other');
  const modalRoleOtherDiv = document.getElementById('modal-sf-role-other-field');

  const modalFormErrorMessage = document.getElementById('modal-form-error-message');
  const modalSegregationErrorMessage = document.getElementById('modal-cart-segregation-error');

  document.querySelectorAll('.product-card__add-button').forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      const productTitle = this.dataset.productTitle;
      const productTags = this.dataset.productTags;
      const variantId = this.dataset.variantId;
      const productHandle = this.dataset.productHandle;

      if (modalProductTitleSpan) modalProductTitleSpan.textContent = productTitle;
      if (modalProductVariantIdInput) modalProductVariantIdInput.value = variantId;
      if (modalProductTagsInput) modalProductTagsInput.value = productTags;
      if (modalProductHandleInput) modalProductHandleInput.value = productHandle;

      customProductAddForm.reset();
      hideModalErrors();
      toggleOtherField(modalRoleField, modalRoleOtherDiv, modalRoleOtherInput, false);
      toggleOtherField(modalPurposeField, modalPurposeOtherDiv, modalPurposeOtherInput, false);
      validateModalForm();

      if (customFormModal) customFormModal.setAttribute('aria-modal', 'true');
    });
  });

  if (customFormModalCloseButton) {
    customFormModalCloseButton.addEventListener('click', closeModal);
  }
  if (customFormModal) {
    customFormModal.addEventListener('click', function(event) {
      if (event.target === customFormModal) {
        closeModal();
      }
    });
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && customFormModal.getAttribute('aria-modal') === 'true') {
        closeModal();
      }
    });
  }

  function closeModal() {
    if (customFormModal) customFormModal.removeAttribute('aria-modal');
    hideModalErrors();
  }

  function toggleOtherField(selectElement, otherDiv, otherInputField, runValidation = true) {
    if (!selectElement || !otherDiv || !otherInputField) return;
    if (selectElement.value === 'Other') {
      otherDiv.style.display = 'block';
      otherInputField.setAttribute('required', 'required');
    } else {
      otherDiv.style.display = 'none';
      otherInputField.removeAttribute('required');
      otherInputField.value = '';
    }
    if (runValidation) validateModalForm();
  }

  function validateModalForm() {
    let isValid = true;

    const purposeValue = modalPurposeField.value.trim();
    const purposeOtherValue = modalPurposeOtherInput.value.trim();

    if (purposeValue === '') {
      showModalError(modalPurposeField, modalFormErrorMessage, 'Please select the intended use of these samples.');
      isValid = false;
    } else if (purposeValue === 'Other' && purposeOtherValue === '') {
      showModalError(modalPurposeOtherInput, modalFormErrorMessage, 'Please specify the intended use when "Other" is selected.');
      isValid = false;
    } else {
      hideModalError(modalPurposeField, modalFormErrorMessage);
      hideModalError(modalPurposeOtherInput, modalFormErrorMessage);
    }

    const roleValue = modalRoleField.value.trim();
    const roleOtherValue = modalRoleOtherInput.value.trim();
    if (roleValue === 'Other' && roleOtherValue === '') {
       modalRoleOtherInput.classList.add('error');
    } else {
       modalRoleOtherInput.classList.remove('error');
    }

    if (modalAddToCartButton) {
      if (isValid) {
        modalAddToCartButton.removeAttribute('disabled');
      } else {
        modalAddToCartButton.setAttribute('disabled', 'disabled');
      }
    }
    return isValid;
  }

  function showModalError(fieldElement, errorDiv, message) {
    if (fieldElement) {
      fieldElement.classList.add('error');
    }
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.style.display = 'block';
    }
  }

  function hideModalError(fieldElement, errorDiv) {
    if (fieldElement) {
      fieldElement.classList.remove('error');
    }
    if (errorDiv) {
      if (!errorDiv.querySelector('.error')) {
         errorDiv.style.display = 'none';
      }
    }
  }

  function hideModalErrors() {
    if (modalFormErrorMessage) {
      modalFormErrorMessage.style.display = 'none';
      modalFormErrorMessage.textContent = '';
    }
    if (modalSegregationErrorMessage) {
      modalSegregationErrorMessage.style.display = 'none';
      modalSegregationErrorMessage.textContent = '';
    }
    const allModalFields = customProductAddForm.querySelectorAll('.input, .select');
    allModalFields.forEach(field => field.classList.remove('error'));
  }

  async function getCartStatus() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (cart.item_count === 0) {
        return 'empty';
      }

      let hasSampleProducts = false;
      let hasExpressProducts = false;

      cart.items.forEach(item => {
        // Check if product_tags exists on the item directly (for older Dawn or simple add)
        // Or if custom property '_product_tags' was set via the modal
        const itemTags = item.properties && item.properties['_product_tags']
            ? item.properties['_product_tags'].split(',')
            : (item.product_has_only_default_variant && item.product_tags ? item.product_tags : []);

        if (itemTags.includes('sample')) {
          hasSampleProducts = true;
        }
        if (itemTags.includes('express')) {
          hasExpressProducts = true;
        }
      });

      if (hasSampleProducts && hasExpressProducts) {
        return 'mixed';
      } else if (hasSampleProducts) {
        return 'sample';
      } else if (hasExpressProducts) {
        return 'express';
      } else {
        return 'other'; // Products in cart but neither sample nor express
      }

    } catch (error) {
      console.error('Error fetching cart status:', error);
      return 'error';
    }
  }

  if (customProductAddForm) {
    customProductAddForm.addEventListener('submit', async function(event) {
      event.preventDefault();
      hideModalErrors();

      const formIsValid = validateModalForm();
      if (!formIsValid) {
        return;
      }

      const currentProductTags = modalProductTagsInput.value.split(',');
      const addingItemIsSample = currentProductTags.includes('sample');
      const addingItemIsExpress = currentProductTags.includes('express');

      if (!addingItemIsSample && !addingItemIsExpress) {
        submitProductToCart(); // Original submit for non-segregated products
        return;
      }

      const cartStatus = await getCartStatus();

      let conflict = false;
      let segregationMessage = '';

      if (cartStatus === 'error') {
        segregationMessage = 'An error occurred while checking your cart. Please try again.';
        conflict = true;
      } else if (cartStatus !== 'empty' && cartStatus !== 'other') {
        if (addingItemIsSample && (cartStatus === 'express' || cartStatus === 'mixed')) {
          conflict = true;
          segregationMessage = 'Please remove Express Shop products from your cart before adding Sample Shop products.';
        } else if (addingItemIsExpress && (cartStatus === 'sample' || cartStatus === 'mixed')) {
          conflict = true;
          segregationMessage = 'Please remove Sample Shop products from your cart before adding Express Shop products.';
        }
      }

      if (conflict) {
        modalSegregationErrorMessage.textContent = segregationMessage;
        modalSegregationErrorMessage.style.display = 'block';
        return;
      } else {
        submitProductToCart();
      }
    });
  }

  async function submitProductToCart() {
    // Use the customFormModal's form for data
    const formData = new FormData(customProductAddForm);
    const data = {};
    // Manually assemble JSON for cart/add.js, ensuring properties are nested
    formData.forEach((value, key) => {
      if (key.startsWith('properties[')) {
        const propKey = key.substring(11, key.length - 1); // Extract key inside properties[]
        if (!data.properties) data.properties = {};
        data.properties[propKey] = value;
      } else {
        data[key] = value;
      }
    });

    // Add hidden product tags from modalProductTagsInput to properties
    if (modalProductTagsInput && modalProductTagsInput.value) {
        if (!data.properties) data.properties = {};
        data.properties['_product_tags'] = modalProductTagsInput.value;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        const result = await response.json();
        closeModal();

        // Dispatch events Dawn typically listens for to update cart UI
        document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { cart: result } }));
        document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));

        // Refresh header to update cart count
        fetch('/?section_id=header')
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newHeader = doc.querySelector('[data-section-id="header"]');
            const currentHeader = document.querySelector('[data-section-id="header"]');

            if (newHeader && currentHeader) {
              currentHeader.innerHTML = newHeader.innerHTML;
            } else {
                console.warn('Custom Quick Add: Could not find header section with data-section-id="header" to update. Ensure this attribute is added to your header.liquid file.');
            }
          })
          .catch(error => {
            console.error('Custom Quick Add: Error fetching and updating header section:', error);
          });

      } else {
        const errorResult = await response.json();
        let errorMessage = 'Failed to add product to cart.';
        if (errorResult.description) errorMessage = errorResult.description;
        if (errorResult.message) errorMessage = errorResult.message;
        showModalError(null, modalSegregationErrorMessage, errorMessage);
      }
    } catch (error) {
      showModalError(null, modalSegregationErrorMessage, 'Network error. Please try again.');
    }
  }


  if (customProductAddForm) {
      modalPurposeField.addEventListener('change', () => toggleOtherField(modalPurposeField, modalPurposeOtherDiv, modalPurposeOtherInput));
      modalPurposeOtherInput.addEventListener('input', validateModalForm);
      modalRoleField.addEventListener('change', () => toggleOtherField(modalRoleField, modalRoleOtherDiv, modalRoleOtherInput));
      modalRoleOtherInput.addEventListener('input', validateModalForm);

      validateModalForm();
  }

  // --- NEW LOGIC FOR GENERAL PRODUCT FORMS AND QUICK ADD MODALS ---

  // Custom element for Product Forms to inject segregation logic
  if (!customElements.get('product-form-wrapper')) {
    class ProductFormWrapper extends HTMLElement {
      constructor() {
        super();
        this.productForm = this.querySelector('form[data-type="add-to-cart-form"]');
        this.addToCartButton = this.querySelector('[name="add"]'); // This targets the actual "Add to Cart" or "Choose options" button
        this.productCard = this.closest('.product-card, .grid__item, .product');
        this.segregationErrorMessageElement = null; // To hold our custom error message element

        if (this.productForm) {
          // For direct add to cart forms
          this.productForm.addEventListener('submit', this.handleSegregationSubmit.bind(this));
        } else if (this.addToCartButton && this.addToCartButton.closest('modal-opener')) {
            // For quick add modal opener buttons
            this.addToCartButton.addEventListener('click', this.handleSegregationModalOpen.bind(this));
        }
        // Add a click listener to the overall product card to clear previous messages if navigating away etc.
        this.addEventListener('click', () => this.hideErrorMessage());
      }

      // Handles direct 'add to cart' submission for single-variant products
      async handleSegregationSubmit(event) {
        event.preventDefault(); // CRITICAL: Stop Dawn's default submission entirely

        const productData = this.getProductData();

        if (!productData.tags.includes('sample') && !productData.tags.includes('express')) {
            // If product is not tagged for segregation, allow it to be added by Dawn's default
            // Since we're preventing default, we need to manually trigger the add
            this.submitToCart(productData);
            return;
        }

        const cartStatus = await getCartStatus(); // Reuse existing function

        let conflict = false;
        let segregationMessage = '';

        if (cartStatus === 'error') {
          segregationMessage = 'An error occurred while checking your cart. Please try again.';
          conflict = true;
        } else if (cartStatus !== 'empty' && cartStatus !== 'other') {
          if (productData.tags.includes('sample') && (cartStatus === 'express' || cartStatus === 'mixed')) {
            conflict = true;
            segregationMessage = `Cannot add "${productData.title}": Please remove Express Shop products from your cart before adding Sample Shop products.`;
          } else if (productData.tags.includes('express') && (cartStatus === 'sample' || cartStatus === 'mixed')) {
            conflict = true;
            segregationMessage = `Cannot add "${productData.title}": Please remove Sample Shop products from your cart before adding Express Shop products.`;
          }
        }

        if (conflict) {
          this.displayErrorMessage(segregationMessage);
          // DO NOT proceed with submission if there's a conflict
        } else {
          this.hideErrorMessage(); // Clear any previous errors
          this.submitToCart(productData); // Proceed with manual AJAX add to cart
        }
      }

      // Handles opening the Quick Add Modal for multi-variant products
      async handleSegregationModalOpen(event) {
          event.preventDefault(); // CRITICAL: Prevent Dawn's modal opening initially

          const productData = this.getProductData();

          if (!productData.tags.includes('sample') && !productData.tags.includes('express')) {
              // If not a segregated product, allow Dawn's modal opener to do its thing
              // We can't simply re-trigger event.target.click() as it might cause an infinite loop.
              // Instead, we manually trigger the modal's open state and fetch its content.
              this.openQuickAddModal(this.addToCartButton.dataset.productUrl);
              return;
          }

          const cartStatus = await getCartStatus();

          let conflict = false;
          let segregationMessage = '';

          if (cartStatus === 'error') {
            segregationMessage = 'An error occurred while checking your cart. Please try again.';
            conflict = true;
          } else if (cartStatus !== 'empty' && cartStatus !== 'other') {
            if (productData.tags.includes('sample') && (cartStatus === 'express' || cartStatus === 'mixed')) {
              conflict = true;
              segregationMessage = `Cannot add "${productData.title}": Please remove Express Shop products from your cart before adding Sample Shop products.`;
            } else if (productData.tags.includes('express') && (cartStatus === 'sample' || cartStatus === 'mixed')) {
              conflict = true;
              segregationMessage = `Cannot add "${productData.title}": Please remove Sample Shop products from your cart before adding Express Shop products.`;
            }
          }

          if (conflict) {
            this.displayErrorMessage(segregationMessage);
            // DO NOT open modal if there's a conflict
          } else {
            this.hideErrorMessage(); // Clear any previous errors
            this.openQuickAddModal(this.addToCartButton.dataset.productUrl); // Open modal for variant selection
          }
      }

      // Manually opens the quick add modal and loads its content
      async openQuickAddModal(productUrl) {
        const modalId = this.addToCartButton.dataset.modal;
        const modalElement = document.querySelector(modalId);
        const infoContainer = modalElement ? modalElement.querySelector('.quick-add-modal__content-info') : null;

        if (!modalElement || !infoContainer) {
            console.error('Quick Add Modal elements not found.');
            return;
        }

        // Show loading spinner
        this.addToCartButton.setAttribute('aria-busy', 'true');
        this.addToCartButton.querySelector('.loading-spinner')?.classList.remove('hidden');

        try {
            // Fetch the quick add info dynamically
            const response = await fetch(`${productUrl}?view=quick_add_info`); // Shopify typically uses a view for quick add content
            const html = await response.text();
            infoContainer.innerHTML = html;

            // Activate Dawn's form/variant selectors within the modal if they are custom elements
            const formElements = infoContainer.querySelectorAll('variant-selects, product-form');
            formElements.forEach(element => {
                if (element.tagName === 'VARIANT-SELECTS' && typeof window.VariantSelects === 'function') {
                    // Re-initialize VariantSelects if it's a custom element and not already initialized
                    // This might be tricky if Dawn already initialized it.
                    // A simple solution is to remove/re-add the element, or trust Dawn's re-initialization
                    // based on inner HTML change.
                } else if (element.tagName === 'PRODUCT-FORM' && typeof window.ProductForm === 'function') {
                    // Similar for ProductForm
                }
            });

            // Set modal to open state
            modalElement.setAttribute('aria-modal', 'true');
            modalElement.focus();
            document.body.classList.add('overflow-hidden');

        } catch (error) {
            console.error('Error opening Quick Add Modal:', error);
            this.displayErrorMessage('Failed to open product options. Please try refreshing the page.');
        } finally {
            // Hide loading spinner
            this.addToCartButton.removeAttribute('aria-busy');
            this.addToCartButton.querySelector('.loading-spinner')?.classList.add('hidden');
        }
      }


      // Helper to get product data from the surrounding context
      getProductData() {
        let tags = this.dataset.productTags || '';
        let title = this.dataset.productTitle || '';

        // Fallback: If tags/title not directly on wrapper, try to get from closest product card button
        if (!tags || !title) {
            const productCard = this.productCard;
            if (productCard) {
                const button = productCard.querySelector('.product-card__add-button, .quick-add__submit');
                if (button) {
                    tags = button.dataset.productTags || tags;
                    title = button.dataset.productTitle || button.closest('.product-card, .grid__item')?.querySelector('.card__heading')?.textContent.trim() || title;
                    if (!title) { // Fallback for specific product templates without card__heading
                        title = productCard.querySelector('h1, .product__title')?.textContent.trim() || 'Product';
                    }
                }
            }
        }

        return {
          title: title,
          tags: tags.split(',')
        };
      }

      // Manually submit product to cart via AJAX
      async submitToCart(productData) {
          if (!this.productForm) {
              console.error('Product form not found for direct add to cart.');
              this.displayErrorMessage('An internal error occurred. Please try again.');
              return;
          }

          // Show loading spinner on the button
          const currentButton = this.productForm.querySelector('[name="add"]');
          if (currentButton) {
              currentButton.setAttribute('aria-busy', 'true');
              currentButton.querySelector('.loading-spinner')?.classList.remove('hidden');
          }

          const formData = new FormData(this.productForm);
          const data = {};
          formData.forEach((value, key) => {
            if (key.startsWith('properties[')) {
              const propKey = key.substring(11, key.length - 1);
              if (!data.properties) data.properties = {};
              data.properties[propKey] = value;
            } else {
              data[key] = value;
            }
          });

          // Add product tags to properties for cart status tracking
          if (productData.tags && productData.tags.length > 0) {
              if (!data.properties) data.properties = {};
              data.properties['_product_tags'] = productData.tags.join(',');
          }

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(data)
            });

            if (response.ok) {
              const result = await response.json();
              // Dispatch events Dawn typically listens for to update cart UI
              document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { cart: result } }));
              document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));

              // Refresh header to update cart count
              fetch('/?section_id=header')
                .then(response => response.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newHeader = doc.querySelector('[data-section-id="header"]');
                  const currentHeader = document.querySelector('[data-section-id="header"]');

                  if (newHeader && currentHeader) {
                    currentHeader.innerHTML = newHeader.innerHTML;
                  }
                })
                .catch(error => {
                  console.error('Error fetching and updating header section:', error);
                });

            } else {
              const errorResult = await response.json();
              let errorMessage = 'Failed to add product to cart.';
              if (errorResult.description) errorMessage = errorResult.description;
              if (errorResult.message) errorMessage = errorResult.message;
              this.displayErrorMessage(errorMessage);
            }
          } catch (error) {
            this.displayErrorMessage('Network error. Please try again.');
          } finally {
              // Hide loading spinner
              if (currentButton) {
                  currentButton.removeAttribute('aria-busy');
                  currentButton.querySelector('.loading-spinner')?.classList.add('hidden');
              }
          }
      }


      displayErrorMessage(message) {
        this.hideErrorMessage(); // Clear previous message first
        if (!this.segregationErrorMessageElement) {
          this.segregationErrorMessageElement = document.createElement('p');
          this.segregationErrorMessageElement.className = 'product-card__error-message text-with-icon';
          this.segregationErrorMessageElement.style.color = 'var(--color-critical)'; // Shopify's error color
          this.segregationErrorMessageElement.style.marginTop = '1rem';
          this.segregationErrorMessageElement.style.fontSize = 'var(--font-body-size)';
          this.segregationErrorMessageElement.innerHTML = `
            <span class="icon-wrap">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.5" r="5.5" fill="none" stroke-width="1"></circle>
                <circle cx="6.5" cy="6.5" r="0.5" fill="currentColor"></circle>
                <path stroke="currentColor" stroke-width="1" d="M6.5 11.5L6.5 7.5"></path>
              </svg>
            </span>
            <span class="error-text"></span>
          `;
          // Insert error message after the add to cart button or form
          if (this.addToCartButton) {
            this.addToCartButton.parentNode.insertBefore(this.segregationErrorMessageElement, this.addToCartButton.nextSibling);
          } else if (this.productForm) {
            this.productForm.parentNode.insertBefore(this.segregationErrorMessageElement, this.productForm.nextSibling);
          } else if (this.productCard) { // Fallback if no specific button/form found
            this.productCard.appendChild(this.segregationErrorMessageElement);
          }
        }
        this.segregationErrorMessageElement.querySelector('.error-text').textContent = message;
        this.segregationErrorMessageElement.classList.remove('hidden');

        // Set a timeout to hide the message after a few seconds
        setTimeout(() => {
          this.hideErrorMessage();
        }, 7000); // Hide after 7 seconds
      }

      hideErrorMessage() {
        if (this.segregationErrorMessageElement) {
          this.segregationErrorMessageElement.classList.add('hidden');
          this.segregationErrorMessageElement.querySelector('.error-text').textContent = '';
        }
      }
    }
    customElements.define('product-form-wrapper', ProductFormWrapper);
  }
  // --- END NEW LOGIC ---
});